<div class="editable-list">
  <ion-grid class="editable-list__title-row">
    <ion-row>
      <ion-col size="4">
        <div class="editable-list__title">{{ title }}</div>
      </ion-col>
      <ion-col size="8" class="editable-list__btns">
        <ng-container *ngIf="isViewOnly; else elseTemplate">
          <ui-custom-button
            [buttonType]="'TERITIARY'"
            [btnTxt]="'Edit Checklist'"
            (clickEvent)="onEdit()"
          ></ui-custom-button>
        </ng-container>
        <ng-template #elseTemplate>
          <span class="editable-list__cancel">
            <ui-custom-button
              [buttonType]="'SECONDARY'"
              [btnTxt]="'Cancel'"
              [buttonWidth]="'120px'"
              (clickEvent)="dimissModal()"
            ></ui-custom-button>
          </span>
          <ui-custom-button
            [buttonType]="'PRIMARY'"
            [btnTxt]="'Save'"
            [buttonWidth]="'120px'"
            (clickEvent)="onSave()"
          ></ui-custom-button>
        </ng-template>
      </ion-col>
    </ion-row>
    <ion-row class="editable-list__subtitle-row">
      <ion-col>
        <div *ngIf="subtitle" class="editable-list__subtitle">{{ subtitle }}</div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div class="editable-list__content">
    <ion-row *ngIf="header" class="editable-list__header-container">
      <ion-col *ngFor="let headerItem of header">
        <div class="editable-list__header-label">{{ headerItem.label }}</div>
        <div class="editable-list__header-value">{{ headerItem.value }}</div>
      </ion-col>
    </ion-row>
    <div>
      <ol class="editable-list__task-list">
        <li *ngFor="let item of updatedEditList" class="editable-list__task">
          <ng-container *ngIf="isViewOnly; else editableTxt">
            <div class="editable-list__view-task">{{ item.name }}</div>
          </ng-container>
          <ng-template #editableTxt>
            <ion-item lines="none" class="editable-list__item">
              <ion-input
                slot="start"
                [(ngModel)]="item.name"
                class="editable-list__input"
                [ngClass]="{ 'read-only': item.isReadOnly }"
                [readonly]="item.isReadOnly"
              ></ion-input>
              <ion-icon *ngIf="item.deletable" (click)="deleteRow(item)" slot="end" name="trash-outline"></ion-icon>
            </ion-item>
          </ng-template>
        </li>
      </ol>
      <ng-container *ngIf="!isViewOnly">
        <div class="editable-list__add-task">
          <ui-custom-button
            [buttonType]="'TERITIARY'"
            [btnTxt]="'+ Add more'"
            (clickEvent)="onAddAnotherStep()"
          ></ui-custom-button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
